export class InscripcionPlanCompensacion {
    tipoIdFuncionario: string;
    numeroIdFuncionario: string;
    nombreCompleto: string;
    turno: string;
    fechaInicial: Date;
    fechaFinal: Date;
    estado: string;
}